import React, { useEffect, useReducer, useState } from 'react'
import ReactQuill from 'react-quill'
import { Link, useParams } from 'react-router-dom'
import { APIKEY, MAX_UPLOAD } from '../../data/constant'
import { ACTION_TYPES, Product, SingleProduct } from '../../reducer'

function EditProduct() {
    const {slug} = useParams()
    const [state, dispatch] = useReducer(SingleProduct, Product)
    useEffect(() => {
        const fetchData = async () => {
            dispatch({type:ACTION_TYPES.PRODUCT_START})
            try{
                const response = await fetch('http://localhost:3000/api/v1/products/by-identity?identity='+slug)
                if (!response.ok)
                    throw new Error(`Error: ${response.statusText}`)
                const data = await response.json()
                dispatch({type:ACTION_TYPES.PRODUCT_SUCCESS, payload:data.response})
            }catch(err){
                dispatch({type:ACTION_TYPES.PRODUCT_ERROR, payload:err.message})
            }
        }
        fetchData()
    },[slug])
    const initial = {
        name:'',
        slug:'',
        category:'',
        price:'',
        status:'',
        description:'',
        benefits:'',
        prescription:'',
        featured:'',
        //images:[]
    }
    const [formData, setFormData] = useState(initial)
    const [image, setImage] = useState('')
    const [loading, setLoading] = useState(false)
    const onChangeValue = (e) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }
    const handleDescribe = (value) => {
        setFormData({
            ...formData,
            description:value
        })
    }
    const handleBenefits = (value) => {
        setFormData({
            ...formData,
            benefits:value
        })
    }
    const handlePrescribe = (value) => {
        setFormData({
            ...formData,
            prescription:value
        })
    }
    const uploadImage = async (img) => {
        if (img.size > MAX_UPLOAD){
            alert('File too large')
            return;
        }
        const formData = new FormData()
        formData.append("image", img)
        const response = await fetch(`https://api.imgbb.com/1/upload?key=${APIKEY}`, {
            method:'POST',
            body:formData
        })
        if (!response.ok) {
            alert('Failed to upload.')
            return
        } else
            return response.json().url
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
    }
  return (
    <>
        <div class="profile-header">
            <div class="profile-header-inner">
                <div class="profile-avatar">
                    <img class="avatar" src="https://via.placeholder.com/250x250" alt="" data-demo-src="./../assets/img/avatars/helen.jpg" />
                    <h2 class="title is-4 is-narrow">Helen Miller</h2>
                    <p class="subtitle is-6">Administrator</p>
                </div>

                <div class="tabs is-centered">
                    <ul>
                        <li><Link to="/admin/product-management">Products</Link></li>
                        <li class="is-active"><a href="/admin/add-new-product">Create New</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="section is-app-grey">
            <div class="container">
                <div class="profile-wrapper">
                    <div class="columns is-vcentered">
                        <div class="column is-12 is-offset-0">
                            <div class="flex-card light-bordered light-raised">
                                <div class="card-body">
                                    <div class="pb-20">
                                        <h3 class="title is-4 is-styled">Manage Product</h3>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div class="columns pt-10">
                                            <div class="column">
                                                <div class="field">
                                                    <div class="control">
                                                        <label>Product Name</label>
                                                        <input class="input is-medium mt-5" type="text" name="name" onChange={onChangeValue} value={formData.name} required />
                                                    </div>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <label>Category</label>
                                                        <div class="mt-5"></div>
                                                        <select class="select" data-placeholder="Product category" name="category" onChange={onChangeValue} value={formData.category} required>
                                                            <option label="Product catgeory"></option>
                                                            <option value="Regulatory Series">Regulatory Series</option>
                                                            <option value="Nourishing Series">Nourishing Series</option>
                                                            <option value="Cleansing Series">Cleansing Series</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="field">
                                                    <div class="control">
                                                        <label>Price (NGN)</label>
                                                        <input class="input is-medium mt-5" type="number" name="price" onChange={onChangeValue} value={formData.price} required />
                                                    </div>
                                                </div>
                                                <div class="field">
                                                    <div class="control">
                                                        <label>Visibility</label>
                                                        <div class="mt-5"></div>
                                                        <select class="select" data-placeholder="Product Status" onChange={onChangeValue} name="status" value={formData.status}>
                                                            <option label="Product Status"></option>
                                                            <option value="visible">Visible</option>
                                                            <option value="hidden">Hidden</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <div class="field">
                                                    <div class="control">
                                                        <ReactQuill theme="snow" value={formData.description} onChange={handleDescribe} placeholder='Enter description text here...' />
                                                        {/* <textarea class="textarea is-grow" name="description" onChange={onChangeValue} rows="5" placeholder="Enter a product description ..."></textarea> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <div class="field">
                                                    <div class="control">
                                                        <ReactQuill theme="snow" value={formData.benefits} onChange={handleBenefits} placeholder='List product benefits here...' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <div class="field">
                                                    <div class="control">
                                                        <ReactQuill theme="snow" value={formData.prescription} onChange={handlePrescribe} placeholder='Enter prescription text here...' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <label>Upload Display Image</label>
                                                <div class="uploader-controls animated preFadeInUp fadeInUp">
                                                    <input type="file" name="fielduploader" onChange={(e) => setImage(e.target.files[0])} value={formData.image} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="columns">
                                            <div class="column">
                                                <label>Upload More Images</label>
                                                <div class="uploader-controls has-text-right animated preFadeInUp fadeInUp">
                                                    <input type="file" name="thumbnails" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="has-text-right">
                                            <button class="button is-light button-cta is-bold no-lh" type="reset">
                                                Cancel
                                            </button>
                                            <button class="button btn-align button-cta is-bold no-lh raised primary-btn" type="submit">
                                                {loading ? 'Sending' : 'Create'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default EditProduct
